import React from 'react';
import { makeAssistantToolUI } from '@assistant-ui/react';

export const DashboardBuildToolUI = makeAssistantToolUI({
  toolName: "build_dashboard",
  render: ({ args, status, result, toolName, toolCallId }) => {
    return (
      <div className="my-4 border-2 border-emerald-500 rounded-lg p-4 bg-emerald-50 dark:bg-emerald-900/20">
        <div className="flex items-center gap-2 mb-3">
          <svg className="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <h4 className="font-semibold text-emerald-900 dark:text-emerald-100">
            Dashboard Building
          </h4>
          <span className={`ml-auto text-xs px-2 py-1 rounded ${
            status.type === 'running'
              ? 'bg-yellow-200 text-yellow-800'
              : status.type === 'complete'
              ? 'bg-green-200 text-green-800'
              : 'bg-gray-200 text-gray-800'
          }`}>
            {status.type}
          </span>
        </div>

        <div className="space-y-3 text-sm">
          {status.type === 'running' && (
            <div className="flex items-center gap-2 text-emerald-700 dark:text-emerald-300">
              <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Building your dashboard...</span>
            </div>
          )}

          <div className="bg-white dark:bg-gray-800 p-3 rounded border border-emerald-200 dark:border-emerald-700">
            <p className="text-gray-700 dark:text-gray-300 mb-2">
              Your dashboard is being created. This typically takes 30-60 seconds.
            </p>
            <a
              href="https://console.plexe.ai/dashboards"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-emerald-600 hover:text-emerald-700 dark:text-emerald-400 dark:hover:text-emerald-300 font-medium text-sm"
            >
              <span>View all dashboards</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>

          {args && Object.keys(args).length > 0 && (
            <details className="text-xs">
              <summary className="cursor-pointer text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200">
                Show details
              </summary>
              <div className="mt-2 space-y-2">
                <div>
                  <div className="font-mono text-xs text-gray-500 dark:text-gray-400 mb-1">Arguments:</div>
                  <pre className="bg-white dark:bg-gray-900 p-2 rounded border border-gray-200 dark:border-gray-700 overflow-x-auto text-xs">
                    {JSON.stringify(args, null, 2)}
                  </pre>
                </div>
                {result && (
                  <div>
                    <div className="font-mono text-xs text-gray-500 dark:text-gray-400 mb-1">Result:</div>
                    <pre className="bg-white dark:bg-gray-900 p-2 rounded border border-gray-200 dark:border-gray-700 overflow-x-auto text-xs">
                      {JSON.stringify(result, null, 2)}
                    </pre>
                  </div>
                )}
              </div>
            </details>
          )}
        </div>
      </div>
    );
  }
});